import React from 'react';
import withIcon from '../utilities/withIcon';

const IconWarning = () => {
  return (
    <g>
      <path d="M8.496 1.136a1 1 0 0 1 .361.36l7.005 12.002A.998.998 0 0 1 14.998 15H1a1 1 0 0 1-.864-1.502L7.129 1.497a1 1 0 0 1 1.367-.361zm-.503 1.856L1.87 13.5h12.256L7.993 2.992zM8 10.5c.38 0 .693.26.743.596l.007.093v.489l-.007.226c-.05.337-.363.596-.743.596s-.693-.26-.743-.596l-.007-.226v-.489l.007-.093c.05-.337.363-.596.743-.596zM8 5c.38 0 .693.279.743.64l.007.1v3.52l-.007.1A.747.747 0 0 1 8 10a.747.747 0 0 1-.743-.64l-.007-.1V5.74l.007-.1A.747.747 0 0 1 8 5z" />
    </g>
  );
};

export default withIcon(IconWarning);
